import { useRouter } from "next/router"
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@rentspree/component-2023.components.atoms.checkbox'

import SpaceBetweenWrapper from "components/atoms/space-between-wrapper"
import { Text } from "components/atoms/typography"
import { COLOR } from "styles/style-constants"

export const priceColorGenerator = (disabled, isSelected, partner) => {
  if (disabled) return COLOR.softGray
  if (!isSelected) return COLOR.softGray
  return COLOR.secondaryPurple
}

const ScreeningOptionItemV2 = ({
  value,
  disabled,
  isShowError,
  label,
  optionPrice,
  toggleOption,
}) => {
  const router = useRouter()
  const { partner } = router.query

  return (
    <SpaceBetweenWrapper style={{ marginLeft: "10px" }}>
      <FormControlLabel
        style={disabled ? { cursor: "not-allowed" } : {}}
        label={label}
        onChange={toggleOption}
        control={
          <Checkbox
            checked={value}
            disabled={disabled}
            color={isShowError ? "error" : "primary"}
          />
        }
      />
      <Text
        weight="400"
        color={priceColorGenerator(disabled, value, partner)}
        margin="0px"
        size="16px">
        {optionPrice}
      </Text>
    </SpaceBetweenWrapper>
  )
}

export default ScreeningOptionItemV2
